import React from 'react';
import PropTypes from 'prop-types';
import './Image.scss';

const DEFAULT_HEIGHT = '43px';
const DEFAULT_WIDTH = '170px';

export const Image = (props) => {
  Image.propTypes = {
    source: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
  };

  const { height, width, source } = props;

  return (
    <div className="image" style={{
      backgroundImage: `url("${source}")`,
      height: height || DEFAULT_HEIGHT,
      minHeight: height || DEFAULT_HEIGHT,
      width: width || DEFAULT_WIDTH,
      minWidth: width || DEFAULT_WIDTH
    }} />
  );
};




// WEBPACK FOOTER //
// ./src/elements/Image/Image.js